import { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import Joi from "joi-browser";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { getLifecycleCbs } from "./common/lifecycleCbs";
import { CampaignTypeIcons } from "../../common/CampaignTypeIcons";
import { CAMPAIGN_TYPE } from "../../BulkCampaigns/BulkCampaignCreate";
import { getFollowUpSettings } from "./common/utils";

const template = [
  {
    name: "followUpDelay",
    label: "Follow-up after (hours) *",
    type: "text",
  },
];

const schema = {
  followUpDelay: Joi.number()
    .min(1)
    .required()
    .label("Follow-up after (hours)")
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "number.base":
            err.message = "Follow-up after (hours) should be a number field";
            break;
          case "any.required":
            err.message = "Follow-up after (hours) is required";
            break;
        }
      });
      return errors;
    }),
};

export default function FollowUpCall({
  followUpSettings,
  setFollowUpSettings,
  itemIndexForEdit,
  handleSave,
  open,
  onClose,
  mode,
}) {
  const [inputField] = useState(
    getFollowUpSettings(
      mode,
      itemIndexForEdit,
      followUpSettings,
      CAMPAIGN_TYPE.CALL
    )
  );
  const [loading, setLoading] = useState(false);

  const { data, validate, handleChange, error } = useForm(inputField, schema);

  const handleSubmit = () => {
    let updatedFollowUps = [];

    const { followUpDelay } = data;
    const updatedData = {
      followUpDelay,
      followUpMessage: "",
      whatsAppFollowUp: {
        templateName: "",
        language: "",
      },
    };

    if (mode === "add") {
      const addedFollowUp = { ...updatedData, order: followUpSettings.length };
      updatedFollowUps = [...followUpSettings, addedFollowUp];
    }

    if (mode === "edit") {
      const editedFollowUp = { ...updatedData, order: itemIndexForEdit };

      updatedFollowUps = followUpSettings.toSpliced(
        itemIndexForEdit,
        1,
        editedFollowUp
      );
    }

    const onInit = () => setLoading(true);

    const onError = () => setLoading(false);

    const onSuccess = () => {
      setFollowUpSettings(updatedFollowUps);
      setLoading(false);
      onClose();
    };
    const lifecycleCbs = getLifecycleCbs(onInit, onSuccess, onError);

    handleSave({ followUpSettings: updatedFollowUps }, lifecycleCbs);
  };

  const isSaveDisabled =
    validate(data, schema) || Boolean(Object.keys(error).length) || loading;

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        <div className="flex gap-x-2 items-center">
          {CampaignTypeIcons[CAMPAIGN_TYPE.CALL]} Follow-Up Call
        </div>
      </DialogTitle>
      <DialogBody>
        <Form
          data={data}
          template={template}
          handleChange={handleChange}
          error={error}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          disabled={isSaveDisabled}
          onClick={handleSubmit}
        >
          {mode === "edit" ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
